import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18NotiB = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M10.5 15c0 1.2-.672 2-1.5 2s-1.5-.8-1.5-2zM9 2c2.706 0 4.88 2.451 4.88 5.452v3.334l1.388 1.253a.71.71 0 0 1 .232.53v.731c0 .387-.298.7-.666.7H3.166c-.368 0-.666-.313-.666-.7v-.73c0-.205.085-.399.232-.531l1.388-1.253V7.452C4.12 4.452 6.294 2 9 2"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18NotiB$1 = Svg18NotiB;

export { Svg18NotiB$1 as default };
